import getConfig from 'next/config'

type Feature =
  | 'ABTESTING'
  | 'ADDRESSBOOK'
  | 'CART_V2'
  | 'CONTACTLENS_STOCK'
  | 'CROSS_SELL'
  | 'MYACCOUNT'
  | 'CONTACTLENS'
  | 'SOLUTIONS'
  | 'PRESCRIPTION_GLASSES'
  | 'TABS'
  | 'MULTILINGUAL'
  | 'REVIEWS'
  | 'STOCK'
  | 'VTO'
  | 'BYNDER_IMAGES'

type FeatureCheck = () => boolean

let enabledFeatures: string[] | undefined

const getEnabledFeatures = () => {
  enabledFeatures = getConfig().publicRuntimeConfig.grandvision.features as string[]

  if (typeof window === 'undefined') {
    // tslint:disable-next-line: no-console
    console.info(`Feature toggles enabled: ${enabledFeatures.length ? enabledFeatures : '-'}`)
  }
}

const isFeatureEnabled = (feature: Feature): boolean => {
  if (!enabledFeatures) {
    getEnabledFeatures()
  }
  return enabledFeatures?.some((e) => e.toUpperCase() === feature.toUpperCase()) || false
}

export const isABTestingEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'ABTESTING')
export const isAddressBookEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'ADDRESSBOOK')
export const isCrossSellEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'CROSS_SELL')
export const isMyAccountEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'MYACCOUNT')
export const isContactLensEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'CONTACTLENS')
export const isReviewsEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'REVIEWS')
export const isSolutionsEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'SOLUTIONS')
export const isTabsEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'TABS')
export const isMultilingualEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'MULTILINGUAL')
export const isStockEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'STOCK')
export const isVtoEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'VTO')
export const isContactLensStockEnabled: FeatureCheck = isFeatureEnabled.bind(
  null,
  'CONTACTLENS_STOCK'
)

export const isPrescriptionGlassesEnabled: FeatureCheck = isFeatureEnabled.bind(
  null,
  'PRESCRIPTION_GLASSES'
)

export const isCartV2Enabled: FeatureCheck = isFeatureEnabled.bind(null, 'CART_V2')
export const isBynderImagesEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'BYNDER_IMAGES')
